var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ProximaNovaFormats = [
    {
        format: null,
        fileExt: "eot"
    },
    {
        format: "opentype",
        fileExt: "otf"
    },
    {
        format: "woff2",
        fileExt: "woff2"
    },
    {
        format: "woff",
        fileExt: "woff"
    }
];
var PartialSvgFormat = { format: "svg", fileExt: "svg" };
var ProximaNovaFontDef = {
    name: "Proxima Nova",
    defaultFormats: ProximaNovaFormats,
    variants: [
        {
            localNames: ["Proxima Nova Regular", "Proxima Nova", "ProximaNova"],
            fontWeight: 400,
            fontStyle: "normal",
            assetName: "Proxima Nova Regular",
            formats: [__assign(__assign({}, PartialSvgFormat), { fileFragment: "ProximaNova-Regular" })]
        },
        {
            localNames: [
                "Proxima Nova Regular Bold",
                "Proxima Nova Bold",
                "ProximaNovaRegularBold"
            ],
            fontWeight: 700,
            fontStyle: "normal",
            assetName: "Proxima Nova Bold",
            formats: [__assign(__assign({}, PartialSvgFormat), { fileFragment: "ProximaNova-Bold" })]
        },
        {
            localNames: [
                "Proxima Nova Regular Italic",
                "Proxima Nova Italic",
                "ProximaNovaRegularItalic"
            ],
            fontWeight: 400,
            fontStyle: "italic",
            assetName: "Proxima Nova Regular Italic",
            formats: [__assign(__assign({}, PartialSvgFormat), { fileFragment: "ProximaNova-RegularIt" })]
        },
        {
            localNames: ["Proxima Nova Bold Italic", "ProximaNovaBoldItalic"],
            fontWeight: 700,
            fontStyle: "italic",
            assetName: "Proxima Nova Bold Italic",
            formats: [__assign(__assign({}, PartialSvgFormat), { fileFragment: "ProximaNova-BoldIt" })]
        },
        {
            localNames: ["Proxima Nova Light", "ProximaNovaLight"],
            fontWeight: 300,
            fontStyle: "normal",
            assetName: "Proxima Nova Light",
            formats: [__assign(__assign({}, PartialSvgFormat), { fileFragment: "ProximaNova-Light" })]
        },
        {
            localNames: ["Proxima Nova Light Italic", "ProximaNovaLightItalic"],
            fontWeight: 300,
            fontStyle: "italic",
            assetName: "Proxima Nova Light Italic",
            formats: [__assign(__assign({}, PartialSvgFormat), { fileFragment: "ProximaNova-LightIt" })]
        },
        {
            localNames: ["Proxima Nova Thin", "ProximaNovaThin"],
            fontWeight: 100,
            fontStyle: "normal",
            assetName: "Proxima Nova Thin",
            formats: [__assign(__assign({}, PartialSvgFormat), { fileFragment: "ProximaNova-Thin" })]
        },
        {
            localNames: ["Proxima Nova Thin Italic", "ProximaNovaThinItalic"],
            fontWeight: 100,
            fontStyle: "italic",
            assetName: "Proxima Nova Thin Italic",
            formats: [__assign(__assign({}, PartialSvgFormat), { fileFragment: "ProximaNova-ThinIt" })]
        },
        {
            localNames: ["Proxima Nova Semibold", "ProximaNovaSemibold"],
            fontWeight: 600,
            fontStyle: "normal",
            assetName: "Proxima Nova Semibold",
            formats: [__assign(__assign({}, PartialSvgFormat), { fileFragment: "ProximaNova-Semibold" })]
        },
        {
            localNames: ["Proxima Nova Extrabold", "ProximaNovaExtrabold"],
            fontWeight: 800,
            fontStyle: "normal",
            assetName: "Proxima Nova Extrabold",
            formats: [__assign(__assign({}, PartialSvgFormat), { fileFragment: "ProximaNova-Extrabold" })]
        },
        {
            localNames: [
                "Proxima Nova Extrabold Italic",
                "ProximaNovaExtraboldItalic"
            ],
            fontWeight: 800,
            fontStyle: "italic",
            assetName: "Proxima Nova Extrabold Italic",
            formats: [
                __assign(__assign({}, PartialSvgFormat), { fileFragment: "ProximaNova-ExtraboldIt" })
            ]
        },
        {
            localNames: ["Proxima Nova Black", "ProximaNovaBlack"],
            fontWeight: 900,
            fontStyle: "normal",
            assetName: "Proxima Nova Black",
            formats: [__assign(__assign({}, PartialSvgFormat), { fileFragment: "ProximaNova-Black" })]
        }
    ]
};
export default ProximaNovaFontDef;
//# sourceMappingURL=proxima-nova.js.map